import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface AddButtonProps {
	onClick: () => void;
	count?: number;
	className?: string;
}

const AddButton = ({ onClick, className }: AddButtonProps) => {
	const { t } = useTranslation();

	return (
		<Button
			type="button"
			variant="outline"
			size="sm"
			onClick={onClick}
			icon={<Plus className="h-4 w-4" />}
			data-testid="employees-add-button"
			className={className || 'w-full sm:w-auto'}
		>
			{t('quotes.settings.employees.add')}
		</Button>
	);
};

export default AddButton;
